import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@core/i18n-legacy';
import { OfferStatus, StatusChangeType } from '@core/offers-types';
import {
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  IconButtonComponent,
  IconComponent,
  OverlayOriginDirective,
} from '@core/user-interface-legacy';
import { JobActionsDropdownOffer, JobActionsDropdownType } from '@recruitee/offers-types';

@Component({
  selector: 'rt-job-actions-dropdown',
  templateUrl: './job-actions-dropdown.component.html',
  styleUrls: ['./job-actions-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconButtonComponent,
    OverlayOriginDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    RouterLink,
    IconComponent,
    TranslatePipe,
  ],
})
export class JobActionsDropdownComponent {
  protected readonly ActionType = StatusChangeType;
  protected readonly OfferStatus = OfferStatus;
  protected readonly DropdownWidth = DropdownWidth;

  public job = input.required<JobActionsDropdownOffer>();
  public type = input.required<JobActionsDropdownType>();
  public canManageJobs = input(false);

  public action = output<StatusChangeType>();
  public trackPreview = output<void>();

  protected isListType = computed(() => this.type() === JobActionsDropdownType.List);
}
